import { useTranslation } from "react-i18next";
import React from 'react';
import { Container, Button } from 'reactstrap';
import { Helmet } from 'react-helmet-async';
import AdminLayout from 'Components/Admin/AdminLayout';
import AllBusinesses from 'Components/Admin/AllBusinesses';
import { Link } from 'react-router-dom';
export default function UserList() {
  const {
    t
  } = useTranslation();
  return <AdminLayout>
      <Button outline color='primary'><Link to='/admin'><h4>{t("Back")}</h4></Link></Button>
      <Helmet>
        <title>{t("Admin business - HeresMyInfo.com")}</title>
      </Helmet>
      <Container fluid>
        <AllBusinesses />
      </Container>
    </AdminLayout>;
}